export default __webpack_public_path__ + "static/media/community-leader-background.51cb5209.png";